import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bsp-container bsp-page" }
const _hoisted_2 = {
  key: 0,
  class: "content bsp-page__content"
}
const _hoisted_3 = {
  class: "bsp-summary-grid",
  "aria-label": "Account summary"
}
const _hoisted_4 = {
  class: "bsp-section phone-numbers",
  "aria-labelledby": "phone-numbers-title"
}
const _hoisted_5 = { class: "bsp-section-heading bsp-section-heading--toolbar" }
const _hoisted_6 = { class: "bsp-section-heading__title-row" }
const _hoisted_7 = {
  key: 0,
  class: "bsp-phone-grid"
}
const _hoisted_8 = { class: "phone-number-info" }
const _hoisted_9 = {
  key: 2,
  class: "bsp-inline-loader"
}
const _hoisted_10 = {
  key: 0,
  class: "bsp-section metrics-section",
  "aria-labelledby": "metrics-title"
}
const _hoisted_11 = { class: "bsp-filter-grid" }
const _hoisted_12 = { class: "bsp-native-field" }
const _hoisted_13 = { class: "bsp-native-field" }
const _hoisted_14 = { class: "bsp-filter-actions" }
const _hoisted_15 = {
  key: 0,
  class: "bsp-table-shell"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { class: "bsp-advanced-section" }
const _hoisted_29 = { class: "bsp-advanced-section__content" }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = { class: "bsp-form-grid bsp-form-grid--phone" }
const _hoisted_32 = { class: "resend-pin" }
const _hoisted_33 = { key: 0 }

import { useRouter, useRoute } from 'vue-router'
import AuthService from '../services/AuthService/AuthService'
import { reactive, onMounted, ref, computed, watch } from 'vue'
import SpinnerLoader from '../components/loaders/SpinnerLoader.vue'
import { User } from '../services/AuthService/types'
import { Establishment } from '../services/EstablishmentService/types'
import { WhatsappBusinessAccount, PhoneNumber } from '../services/AccountService/types'
import { POSITION, useToast } from 'vue-toastification'
import EstablishmentService from '@/services/EstablishmentService/EstablishmentService'
import AccountService from '@/services/AccountService/AccountService'
import MetaService from '@/services/MetaService/MetaService'
import BspPageHeader from '@/components/BspPageHeader.vue'
import {
  AButton,
  AEmptyViewCard,
  AIcon,
  AInformationCard,
  AInput,
  AModal,
  ASelector,
  ATag
} from '@adereso-ai/vue-components'
import {
  aggregateMetrics as aggregateMetricsByPhone,
  buildAnalyticsParams,
  computeTotalAverageDuration,
  downloadAnalyticsReport,
  fetchAnalytics,
  filterMetrics,
  formatDuration,
  getReportFilename as resolveReportFilename,
  type AnalyticsReportParams,
  type AnalyticsType
} from '@/utils/metricsAnalytics'


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsappBusinessAccountView',
  setup(__props) {


const router = useRouter()
const route = useRoute()
const toast = useToast()

const loading = ref(true)
const phoneNumbersLoaded = ref(false)
const currentUser = ref<User | undefined>(undefined)
const currentEstablishment = ref<Establishment | undefined>(undefined)
// const establishmentName = ref('')
const whatsappBusinessAccount = ref<WhatsappBusinessAccount | undefined>(undefined)

const phoneNumbers = ref<PhoneNumber[]>([])
const subcribedAppsResponse = ref<any>(undefined)

const phoneNumberOptions = computed(() => phoneNumbers.value.map((phone) => ({
  value: phone.clean_display_phone_number,
  label: phone.display_phone_number
})))

const analyticsOptions = [
  { title: 'Per message', value: 'pricing' },
  { title: 'Conversations', value: 'conversation' },
  { title: 'Calls', value: 'call' }
]

const accountBreadcrumbs = computed(() => [
  {
    title: 'WhatsApp Accounts',
    icon: 'tabler:brand-whatsapp',
    to: { name: 'whatsapp-business-accounts' }
  },
  {
    title: whatsappBusinessAccount.value?.name || 'Account',
    disabled: true
  }
])

const isAddPhoneNumberModalOpen = ref(false)
const isVerificationStep = ref(false)
const phoneNumberForm = ref({
  cc: '',
  phone_number: '',
  verified_name: ''
})
const numericPhoneIdentifierPattern = /^\d+$/
const pinCode = ref('')
const isCreateButtonEnabled = computed(() => {
  return numericPhoneIdentifierPattern.test(phoneNumberForm.value.cc.trim()) &&
    numericPhoneIdentifierPattern.test(phoneNumberForm.value.phone_number.trim()) &&
    phoneNumberForm.value.verified_name.trim().length > 0
})
const isVerifyButtonEnabled = computed(() => {
  return pinCode.value.trim().length > 0
})
const phoneId = ref('')
const isResendPinDisabled = ref(true)
const resendPinTimer = ref(60)
let resendPinInterval: any = null

const isSuperUser = computed(() => {
  return currentUser.value?.roles.includes('superuser')
})

const metrics = ref<any[]>([])
const filteredMetrics = ref<any[]>([])
const loadingMetrics = ref(false)
const aggregatedMetrics = ref<any[]>([])

const filters = reactive({
  analyticsType: 'pricing' as AnalyticsType,
  startDate: '',
  endDate: '',
  phoneNumbers: [] as { value: string, label: string }[]
})

const totalConversations = computed(() => {
  return aggregatedMetrics.value.reduce(
    (sum, metric) => sum + (metric.conversation ?? 0),
    0
  )
})

const totalVolume = computed(() => {
  return aggregatedMetrics.value.reduce(
    (sum, metric) => sum + (metric.volume ?? 0),
    0
  )
})

const totalCalls = computed(() => {
  return aggregatedMetrics.value.reduce(
    (sum, metric) => sum + (metric.count ?? 0),
    0
  )
})

const totalAverageDuration = computed(() => {
  return computeTotalAverageDuration(aggregatedMetrics.value)
})

const totalCost = computed(() => {
  return aggregatedMetrics.value.reduce((sum, metric) => sum + metric.cost, 0)
})

function applyFilters () {
  filteredMetrics.value = filterMetrics(metrics.value, filters)
  aggregatedMetrics.value = aggregateMetricsByPhone(filteredMetrics.value, filters.analyticsType)
}

function getReportFilename () {
  return resolveReportFilename(filters.analyticsType)
}

function cleanPinCode (value: string) {
  return value.replace(/\D/g, '') // Solo números
}

watch(pinCode, (newValue: string) => {
  pinCode.value = cleanPinCode(newValue)
})

function openAddPhoneNumberModal () {
  isAddPhoneNumberModalOpen.value = true
}

function closeAddPhoneNumberModal () {
  isAddPhoneNumberModalOpen.value = false
  resetAddPhoneNumberModal()
}

function resetAddPhoneNumberModal () {
  isVerificationStep.value = false
  phoneNumberForm.value = {
    cc: '',
    phone_number: '',
    verified_name: ''
  }
  pinCode.value = ''
  phoneId.value = ''
  isResendPinDisabled.value = true
  resendPinTimer.value = 60
  clearInterval(resendPinInterval)
}

async function createPhoneNumber () {
  if (whatsappBusinessAccount.value) {
    loading.value = true
    const metaService = await MetaService.getInstance()
    const payload = {
      cc: phoneNumberForm.value.cc.trim(),
      phone_number: phoneNumberForm.value.phone_number.trim(),
      verified_name: phoneNumberForm.value.verified_name.trim()
    }
    try {
      const response = await metaService.createPhoneNumber(whatsappBusinessAccount.value.id, payload)
      phoneId.value = response.phone_id
      toastSuccess('Phone number created successfully')
      isVerificationStep.value = true
      startResendPinTimer()
    } catch (error) {
      toastError('Error creating phone number: ' + error)
      closeAddPhoneNumberModal()
    }
    loading.value = false
  }
}

async function verifyPhoneNumber () {
  if (phoneId.value && whatsappBusinessAccount.value) {
    loading.value = true
    const metaService = await MetaService.getInstance()
    try {
      await metaService.verifyAndRegisterPhone(phoneId.value, pinCode.value)
      toastSuccess('Phone number verified successfully')
      closeAddPhoneNumberModal()
      await synchronizePhoneNumbers()
    } catch (error) {
      toastError('Error verifying phone number: ' + error)
    }
    loading.value = false
  }
}

function startResendPinTimer () {
  isResendPinDisabled.value = true
  resendPinTimer.value = 60
  resendPinInterval = setInterval(() => {
    resendPinTimer.value--
    if (resendPinTimer.value <= 0) {
      isResendPinDisabled.value = false
      clearInterval(resendPinInterval)
    }
  }, 1000)
}

async function resendPin () {
  if (phoneId.value && whatsappBusinessAccount.value) {
    loading.value = true
    const metaService = await MetaService.getInstance()
    try {
      await metaService.requestPhonePin(whatsappBusinessAccount.value.id, phoneId.value)
      toastSuccess('PIN code resent successfully')
      startResendPinTimer()
    } catch (error) {
      toastError('Error resending PIN code: ' + error)
    }
    loading.value = false
  }
}

async function getEstablishment () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const establishment = await establishmentService.getCurrentEstablishment()
    currentEstablishment.value = establishment
  } catch (error) {
    // do nothing
  }
}

async function goToPhoneNumber (phoneNumberId: string) {
  router.push({ name: 'phone-number', params: { phoneNumberId } })
}

async function geToCreditLine () {
  router.push({ name: 'credit-line', params: { wabaId: whatsappBusinessAccount.value?.id } })
}

async function createSystemUser () {
  loading.value = true
  if (whatsappBusinessAccount.value) {
    const metaService = await MetaService.getInstance()
    try {
      const response = await metaService.createSystemUser(
        whatsappBusinessAccount.value.id,
        '122105581976177242'
      )
      toastSuccess('System user created' + JSON.stringify(response))
    } catch (error) {
      toastError('Error creating system user')
    }
  }
  loading.value = false
}

async function getSubscribedApps () {
  loading.value = true
  if (whatsappBusinessAccount.value) {
    const metaService = await MetaService.getInstance()
    try {
      const response = await metaService.getSubscribedApps(whatsappBusinessAccount.value.id)
      subcribedAppsResponse.value = response
      toastSuccess('Subscribed apps updated' + JSON.stringify(response))
    } catch (error) {
      toastError('Error updating subscribed apps')
    }
  }
  loading.value = false
}

async function subscribeApp () {
  loading.value = true
  if (whatsappBusinessAccount.value) {
    const metaService = await MetaService.getInstance()
    try {
      const response = await metaService.subscribeApp(whatsappBusinessAccount.value.id)
      toastSuccess('App subscribed' + JSON.stringify(response))
    } catch (error) {
      toastError('Error subscribing app')
    }
  }
  loading.value = false
}

async function getWabaSystemUsers () {
  loading.value = true
  if (whatsappBusinessAccount.value) {
    const metaService = await MetaService.getInstance()
    try {
      const response = await metaService.getWabaSystemUsers(whatsappBusinessAccount.value.id)
      toastSuccess('System users updated' + JSON.stringify(response))
    } catch (error) {
      toastError('Error updating system users')
    }
  }
  loading.value = false
}

async function synchronizePhoneNumbers () {
  loading.value = true
  if (whatsappBusinessAccount.value) {
    const metaService = await MetaService.getInstance()
    try {
      await metaService.synchronizeAccountPhoneNumbers(whatsappBusinessAccount.value.id)
      toastSuccess('Phone numbers synchronized')
      await getPhoneNumbers(whatsappBusinessAccount.value.id)
    } catch (error) {
      toastError('Error synchronizing phone numbers')
    }
  }
  loading.value = false
}

/* async function deleteAccount () {
  loading.value = true
  if (whatsappBusinessAccount.value) {
    const accountService = await AccountService.getInstance()
    try {
      await accountService.deleteWhatsappBusinessAccount(whatsappBusinessAccount.value.id)
      toastSuccess('Account deleted')
      goBack()
    } catch (error) {
      toastError('Error deleting account: ' + error)
    }
  }
  loading.value = false
} */

async function getCurrentUser () {
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  if (authService.currentUser.value == null) {
    router.push({ name: 'login', query: route.query })
  }
}

async function getWhatsappBusinessAccount (wabaId: string) {
  try {
    const accountService = await AccountService.getInstance()
    whatsappBusinessAccount.value = await accountService.getWhatsappBusinessAccount(wabaId)
  } catch {
    toastError('Error getting whatsapp business account')
    router.push({ name: 'home' })
  }
}

async function getPhoneNumbers (wabaId: string) {
  try {
    const accountService = await AccountService.getInstance()
    phoneNumbers.value = await accountService.getWhatsappBusinessAccountPhoneNumbers(wabaId)
    filters.phoneNumbers = phoneNumbers.value.map(phone => ({
      value: phone.clean_display_phone_number,
      label: phone.display_phone_number
    }))
  } catch {
    toastError('Error getting whatsapp business account')
  }
}

async function downloadReport () {
  if (!whatsappBusinessAccount.value) return

  loadingMetrics.value = true
  try {
    const metaService = await MetaService.getInstance()
    const params = buildAnalyticsParams(filters, true) as AnalyticsReportParams
    const response = await downloadAnalyticsReport(
      filters.analyticsType,
      metaService,
      whatsappBusinessAccount.value.id,
      params
    )
    const blob = new Blob([response], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', getReportFilename())
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    toastSuccess('Report downloaded successfully')
  } catch (error) {
    toastError('Error downloading report: ' + error)
  }
  loadingMetrics.value = false
}

onMounted(async () => {
  await router.isReady()
  await getCurrentUser()
  await getEstablishment()
  const wabaId = route.params.wabaId as string

  if (wabaId) {
    await getWhatsappBusinessAccount(wabaId)
    await getPhoneNumbers(wabaId)
    await fetchMetrics()
    phoneNumbersLoaded.value = true
    loading.value = false
  } else {
    router.push({ name: 'home' })
  }
})

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}

function toastSuccess (successMessage: string) {
  try {
    toast.success(String(successMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}

async function fetchMetrics () {
  if (!whatsappBusinessAccount.value) return

  loadingMetrics.value = true
  try {
    const metaService = await MetaService.getInstance()
    const params = buildAnalyticsParams(filters)
    const response = await fetchAnalytics(
      filters.analyticsType,
      metaService,
      whatsappBusinessAccount.value.id,
      params
    )
    metrics.value = response.data_points
    applyFilters()
  } catch (error) {
    toastError('Error fetching metrics: ' + error)
  }
  loadingMetrics.value = false
}
function formatCost (value) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)
}
function formatNumber (value) {
  return new Intl.NumberFormat('en-US').format(value)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value && whatsappBusinessAccount.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BspPageHeader, {
            breadcrumbs: accountBreadcrumbs.value,
            title: whatsappBusinessAccount.value.name,
            description: "Manage the phone numbers, settings, and metrics for this account.",
            eyebrow: "WhatsApp Business Account",
            icon: "tabler:brand-whatsapp"
          }, {
            actions: _withCtx(() => [
              (isSuperUser.value)
                ? (_openBlock(), _createBlock(_unref(AButton), {
                    key: 0,
                    variant: "outlined",
                    "prepend-icon": "tabler:credit-card",
                    onClick: geToCreditLine
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" Credit line ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(AButton), {
                color: "blue",
                "prepend-icon": "tabler:refresh",
                onClick: synchronizePhoneNumbers
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" Synchronize phone numbers ", -1)
                ]))]),
                _: 1
              })
            ]),
            meta: _withCtx(() => [
              _createVNode(_unref(ATag), {
                text: `WABA ${whatsappBusinessAccount.value.id}`,
                color: "info",
                type: "secondary"
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["breadcrumbs", "title"]),
          _createElementVNode("section", _hoisted_3, [
            _createVNode(_unref(AInformationCard), {
              title: "Owning business",
              description: whatsappBusinessAccount.value.owner_business_info.name,
              "icon-name": "tabler:building",
              variant: "flat"
            }, null, 8, ["description"]),
            _createVNode(_unref(AInformationCard), {
              title: "Business ID",
              description: whatsappBusinessAccount.value.owner_business_info.id,
              "icon-name": "tabler:fingerprint",
              variant: "flat"
            }, null, 8, ["description"]),
            _createVNode(_unref(AInformationCard), {
              title: "Connected phone numbers",
              description: phoneNumbersLoaded.value ? `${phoneNumbers.value.length} phone numbers` : 'Loading…',
              "icon-name": "tabler:device-mobile",
              variant: "flat"
            }, null, 8, ["description"])
          ]),
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[11] || (_cache[11] = _createElementVNode("h2", { id: "phone-numbers-title" }, "Phone numbers", -1)),
                  (phoneNumbersLoaded.value)
                    ? (_openBlock(), _createBlock(_unref(ATag), {
                        key: 0,
                        text: `${phoneNumbers.value.length}`,
                        color: "primary",
                        type: "secondary"
                      }, null, 8, ["text"]))
                    : _createCommentVNode("", true)
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("p", null, "Select a phone number to manage webhooks, business profile, and templates.", -1))
              ]),
              _createVNode(_unref(AButton), {
                color: "blue",
                "prepend-icon": "tabler:plus",
                onClick: openAddPhoneNumberModal
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode(" Add phone number ", -1)
                ]))]),
                _: 1
              })
            ]),
            (phoneNumbersLoaded.value && phoneNumbers.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phoneNumbers.value, (phoneNumber) => {
                    return (_openBlock(), _createBlock(_component_v_card, {
                      class: "bsp-phone-card",
                      variant: "flat",
                      key: phoneNumber.id,
                      tabindex: "0",
                      onClick: ($event: any) => (goToPhoneNumber(phoneNumber.id)),
                      onKeydown: _withKeys(($event: any) => (goToPhoneNumber(phoneNumber.id)), ["enter"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(AIcon), {
                          icon: "tabler:phone",
                          color: "primary",
                          size: "20",
                          "with-container": ""
                        }),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h3", null, _toDisplayString(phoneNumber.verified_name), 1),
                          _createElementVNode("span", null, _toDisplayString(phoneNumber.display_phone_number), 1)
                        ]),
                        _createVNode(_unref(AButton), {
                          icon: "tabler:chevron-right",
                          variant: "text",
                          size: "small",
                          "help-text": "Manage phone number",
                          onClick: _withModifiers(($event: any) => (goToPhoneNumber(phoneNumber.id)), ["stop"])
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["onClick", "onKeydown"]))
                  }), 128))
                ]))
              : (phoneNumbersLoaded.value)
                ? (_openBlock(), _createBlock(_unref(AEmptyViewCard), {
                    key: 1,
                    icon: "tabler:device-mobile-off",
                    title: "This account has no phone numbers",
                    description: "Add a phone number to start configuring it.",
                    "action-button-label": "Add phone number",
                    onAction: openAddPhoneNumberModal
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(SpinnerLoader),
                    _cache[14] || (_cache[14] = _createElementVNode("span", null, "Loading phone numbers…", -1))
                  ]))
          ]),
          (isSuperUser.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "bsp-section-heading" }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "bsp-section-heading__eyebrow" }, "Analytics"),
                    _createElementVNode("h2", { id: "metrics-title" }, "Account metrics"),
                    _createElementVNode("p", null, "Filter activity by date range and phone numbers before generating the report.")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(ASelector), {
                    modelValue: filters.analyticsType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.analyticsType) = $event)),
                    items: analyticsOptions,
                    "item-title": "title",
                    "item-value": "value",
                    label: "Analytics type"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { for: "startDate" }, "From", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "startDate",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.startDate) = $event))
                    }, null, 512), [
                      [_vModelText, filters.startDate]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { for: "endDate" }, "To", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "endDate",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.endDate) = $event))
                    }, null, 512), [
                      [_vModelText, filters.endDate]
                    ])
                  ]),
                  _createVNode(_unref(ASelector), {
                    modelValue: filters.phoneNumbers,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.phoneNumbers) = $event)),
                    items: phoneNumberOptions.value,
                    "item-title": "label",
                    "item-value": "value",
                    label: "Phone numbers",
                    placeholder: "Select phone numbers",
                    multiple: "",
                    "return-object": "",
                    chips: "",
                    "closable-chips": "",
                    "multiple-max-selection-show": 2
                  }, null, 8, ["modelValue", "items"]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(AButton), {
                      color: "blue",
                      loading: loadingMetrics.value,
                      "prepend-icon": "tabler:filter",
                      onClick: fetchMetrics
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode(" Apply filters ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_unref(AButton), {
                      variant: "outlined",
                      "prepend-icon": "tabler:download",
                      loading: loadingMetrics.value,
                      onClick: downloadReport
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode(" Download report ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ]),
                (aggregatedMetrics.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("table", null, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _cache[19] || (_cache[19] = _createElementVNode("th", null, "Phone number", -1)),
                            (filters.analyticsType === 'conversation')
                              ? (_openBlock(), _createElementBlock("th", _hoisted_16, "Conversations"))
                              : _createCommentVNode("", true),
                            (filters.analyticsType === 'pricing')
                              ? (_openBlock(), _createElementBlock("th", _hoisted_17, "Messages"))
                              : _createCommentVNode("", true),
                            (filters.analyticsType === 'call')
                              ? (_openBlock(), _createElementBlock("th", _hoisted_18, "Calls"))
                              : _createCommentVNode("", true),
                            (filters.analyticsType === 'call')
                              ? (_openBlock(), _createElementBlock("th", _hoisted_19, "Average duration"))
                              : _createCommentVNode("", true),
                            _cache[20] || (_cache[20] = _createElementVNode("th", null, "Cost", -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aggregatedMetrics.value, (metric, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(metric.phone_number), 1),
                              (filters.analyticsType === 'conversation')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(formatNumber(metric.conversation)), 1))
                                : _createCommentVNode("", true),
                              (filters.analyticsType === 'pricing')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(formatNumber(metric.volume)), 1))
                                : _createCommentVNode("", true),
                              (filters.analyticsType === 'call')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(formatNumber(metric.count)), 1))
                                : _createCommentVNode("", true),
                              (filters.analyticsType === 'call')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_unref(formatDuration)(metric.average_duration)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", null, _toDisplayString(formatCost(metric.cost)), 1)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("tfoot", null, [
                          _createElementVNode("tr", null, [
                            _cache[21] || (_cache[21] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Total")
                            ], -1)),
                            (filters.analyticsType === 'conversation')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                  _createElementVNode("strong", null, _toDisplayString(formatNumber(totalConversations.value)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (filters.analyticsType === 'pricing')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                                  _createElementVNode("strong", null, _toDisplayString(formatNumber(totalVolume.value)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (filters.analyticsType === 'call')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                                  _createElementVNode("strong", null, _toDisplayString(formatNumber(totalCalls.value)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (filters.analyticsType === 'call')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(formatDuration)(totalAverageDuration.value)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, [
                              _createElementVNode("strong", null, _toDisplayString(formatCost(totalCost.value)), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : (!loadingMetrics.value)
                    ? (_openBlock(), _createBlock(_unref(AEmptyViewCard), {
                        key: 1,
                        icon: "tabler:chart-bar-off",
                        title: "No metrics to display",
                        description: "Adjust the filters and try again."
                      }))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("details", _hoisted_28, [
            _createElementVNode("summary", null, [
              _cache[23] || (_cache[23] = _createElementVNode("span", null, [
                _createElementVNode("strong", null, "Advanced tools"),
                _createElementVNode("small", null, "Administrative actions for Meta and the WABA.")
              ], -1)),
              _createVNode(_unref(AIcon), {
                icon: "tabler:chevron-down",
                size: "18"
              })
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_unref(AButton), {
                variant: "outlined",
                "prepend-icon": "tabler:refresh",
                onClick: synchronizePhoneNumbers
              }, {
                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createTextVNode(" Synchronize phone numbers ", -1)
                ]))]),
                _: 1
              }),
              (isSuperUser.value)
                ? (_openBlock(), _createBlock(_unref(AButton), {
                    key: 0,
                    variant: "outlined",
                    onClick: getWabaSystemUsers
                  }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createTextVNode(" Get system users ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isSuperUser.value)
                ? (_openBlock(), _createBlock(_unref(AButton), {
                    key: 1,
                    variant: "outlined",
                    onClick: createSystemUser
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode(" Create system user ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isSuperUser.value)
                ? (_openBlock(), _createBlock(_unref(AButton), {
                    key: 2,
                    variant: "outlined",
                    onClick: subscribeApp
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode(" Subscribe app ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isSuperUser.value)
                ? (_openBlock(), _createBlock(_unref(AButton), {
                    key: 3,
                    variant: "outlined",
                    onClick: getSubscribedApps
                  }, {
                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                      _createTextVNode(" Get subscribed apps ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isSuperUser.value && subcribedAppsResponse.value)
                ? (_openBlock(), _createElementBlock("pre", _hoisted_30, _toDisplayString(subcribedAppsResponse.value), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 })),
    _createVNode(_unref(AModal), {
      modelValue: isAddPhoneNumberModalOpen.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isAddPhoneNumberModalOpen).value = $event)),
      title: isVerificationStep.value ? 'Verify phone number' : 'Add phone number',
      "prepend-title-icon": "tabler:device-mobile-plus",
      width: "560px",
      "close-disabled": loading.value,
      onOnClose: closeAddPhoneNumberModal
    }, {
      body: _withCtx(() => [
        (!isVerificationStep.value)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "bsp-modal-form",
              onSubmit: _withModifiers(createPhoneNumber, ["prevent"])
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("p", null, "Enter the information Meta will use to create the phone number.", -1)),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_unref(AInput), {
                  modelValue: phoneNumberForm.value.cc,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((phoneNumberForm.value.cc) = $event)),
                  type: "tel",
                  label: "Country code",
                  placeholder: "56",
                  autocomplete: "tel-country-code",
                  pattern: numericPhoneIdentifierPattern,
                  required: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(AInput), {
                  modelValue: phoneNumberForm.value.phone_number,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((phoneNumberForm.value.phone_number) = $event)),
                  type: "tel",
                  label: "Phone number",
                  placeholder: "912345678",
                  autocomplete: "tel-national",
                  pattern: numericPhoneIdentifierPattern,
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_unref(AInput), {
                modelValue: phoneNumberForm.value.verified_name,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((phoneNumberForm.value.verified_name) = $event)),
                label: "Verified name",
                placeholder: "My business",
                required: ""
              }, null, 8, ["modelValue"]),
              _cache[30] || (_cache[30] = _createElementVNode("p", { class: "bsp-help-text" }, [
                _createTextVNode(" The name must comply with "),
                _createElementVNode("a", {
                  href: "https://web.facebook.com/business/help/757569725593362",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Meta's policies"),
                _createTextVNode(". ")
              ], -1))
            ], 32))
          : (_openBlock(), _createElementBlock("form", {
              key: 1,
              class: "bsp-modal-form",
              onSubmit: _withModifiers(verifyPhoneNumber, ["prevent"])
            }, [
              _cache[32] || (_cache[32] = _createElementVNode("p", null, "Enter the PIN Meta sent to the phone number.", -1)),
              _createVNode(_unref(AInput), {
                modelValue: pinCode.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((pinCode).value = $event)),
                label: "PIN code",
                placeholder: "000000",
                required: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_unref(AButton), {
                  type: "button",
                  variant: "text",
                  size: "small",
                  disabled: isResendPinDisabled.value,
                  onClick: resendPin
                }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode(" Resend PIN ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                (isResendPinDisabled.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, "Available in " + _toDisplayString(resendPinTimer.value) + " seconds.", 1))
                  : _createCommentVNode("", true)
              ])
            ], 32))
      ]),
      actions: _withCtx(() => [
        _createVNode(_unref(AButton), {
          variant: "text",
          disabled: loading.value,
          onClick: closeAddPhoneNumberModal
        }, {
          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"]),
        (!isVerificationStep.value)
          ? (_openBlock(), _createBlock(_unref(AButton), {
              key: 0,
              color: "blue",
              loading: loading.value,
              disabled: !isCreateButtonEnabled.value,
              onClick: createPhoneNumber
            }, {
              default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                _createTextVNode(" Create phone number ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : (_openBlock(), _createBlock(_unref(AButton), {
              key: 1,
              color: "blue",
              loading: loading.value,
              disabled: !isVerifyButtonEnabled.value,
              onClick: verifyPhoneNumber
            }, {
              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                _createTextVNode(" Verify ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled"]))
      ]),
      _: 1
    }, 8, ["modelValue", "title", "close-disabled"])
  ]))
}
}

})